import React, { useState } from 'react';
import { LoadingButton } from '../common/LoadingButton';

export const AuthReceipt = ({ onValidateReceipt }) => {
    const [isSubmitting, setSubmitting] = useState(false)
    const [receipt, setReceipt] = useState("")

    const handleAuth = () => {
        setSubmitting(true)

        // Validate receipt
        onValidateReceipt(receipt, () => { setSubmitting(false) })
    }

    const handleUserInput = (event) => {
        setReceipt(event.target.value)
    }

    return (
        <form noValidate>
            <p className="mb-4 text-center">To view your previous vote, please provide the receipt given at submission.</p>

            <div className="mb-4">
                <label htmlFor="receipt" className="block font-medium mb-2">Vote Receipt</label>
                <input id="receipt" type="text" onChange={handleUserInput} value={receipt} placeholder="Vote Receipt" required />
            </div>

            <div className="mt-8">
                <LoadingButton className="btn w-full block"
                    btnText="Submit"
                    isLoading={isSubmitting}
                    onBtnClick={handleAuth}
                    isSubmit="true">
                    Submit
                </LoadingButton>
            </div>
        </form>
    );
}